enum Mutations {
  SET_MAP_DATA = 'setMapData',
  SET_POSTCODE = 'setPostcode',
  SET_POSTCODES_DATA = 'setPostcodesData',
}

export default Mutations
